/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SwapScreenerLeadResidents200ResponseDataLead1 } from './SwapScreenerLeadResidents200ResponseDataLead1';
import {
    SwapScreenerLeadResidents200ResponseDataLead1FromJSON,
    SwapScreenerLeadResidents200ResponseDataLead1FromJSONTyped,
    SwapScreenerLeadResidents200ResponseDataLead1ToJSON,
    SwapScreenerLeadResidents200ResponseDataLead1ToJSONTyped,
} from './SwapScreenerLeadResidents200ResponseDataLead1';

/**
 * 
 * @export
 * @interface SwapScreenerLeadResidents200ResponseData
 */
export interface SwapScreenerLeadResidents200ResponseData {
    /**
     * 
     */
    lead_1: SwapScreenerLeadResidents200ResponseDataLead1;
    /**
     * 
     */
    lead_2: SwapScreenerLeadResidents200ResponseDataLead1;
}

/**
 * Check if a given object implements the SwapScreenerLeadResidents200ResponseData interface.
 */
export function instanceOfSwapScreenerLeadResidents200ResponseData(value: object): value is SwapScreenerLeadResidents200ResponseData {
    if (!('lead_1' in value) || value['lead_1'] === undefined) return false;
    if (!('lead_2' in value) || value['lead_2'] === undefined) return false;
    return true;
}

export function SwapScreenerLeadResidents200ResponseDataFromJSON(json: any): SwapScreenerLeadResidents200ResponseData {
    return SwapScreenerLeadResidents200ResponseDataFromJSONTyped(json, false);
}

export function SwapScreenerLeadResidents200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SwapScreenerLeadResidents200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_1': SwapScreenerLeadResidents200ResponseDataLead1FromJSON(json['lead_1']),
        'lead_2': SwapScreenerLeadResidents200ResponseDataLead1FromJSON(json['lead_2']),
    };
}

export function SwapScreenerLeadResidents200ResponseDataToJSON(json: any): SwapScreenerLeadResidents200ResponseData {
    return SwapScreenerLeadResidents200ResponseDataToJSONTyped(json, false);
}

export function SwapScreenerLeadResidents200ResponseDataToJSONTyped(value?: SwapScreenerLeadResidents200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_1': SwapScreenerLeadResidents200ResponseDataLead1ToJSON(value['lead_1']),
        'lead_2': SwapScreenerLeadResidents200ResponseDataLead1ToJSON(value['lead_2']),
    };
}

